<template>
  <div class="container-meta">
    <div class="base-data content-body">
      <h4>{{ container.name }}</h4>
      <div class="base-data__fields">
        <p v-if="container.preformatted">
          <span class="material-icons">gps_fixed</span><span>{{ container.preformatted }}</span>
        </p>
        <p v-if="container.type">
          <span class="material-icons">delete_sweep</span><span>{{ container.type.name }}</span>
        </p>
        <p v-if="container.measured_at">
          <span class="material-icons">schedule</span><span>{{ container.measured_at_formatted }}</span>
        </p>
        <p v-if="container.sensors && container.sensors.length > 0">
          <span class="material-icons">sensors</span><span>{{ container.sensors[0].hardware_id }}</span>
        </p>
        <p v-if="container.site_name">
          <span class="material-icons">pin_drop</span><span>{{ container.site_name }}</span>
        </p>
        <p v-if="container.area_name">
          <span class="material-icons">push_pin</span><span>{{ container.area_name }}</span>
        </p>
        <p v-if="container.zone_name">
          <span class="material-icons">location_city</span><span>{{ container.zone_name }}</span>
        </p>
        <p v-if="container.fraction">
          <span class="material-icons">recycling</span><span>{{ container.fraction.localized_name }}</span>
        </p>
        <p v-if="container.company">
          <span class="material-icons">business</span><span>{{ container.company.name }}</span>
        </p>
        <p v-if="container.project">
          <span class="material-icons">all_inbox</span><span>{{ container.project.name }}</span>
        </p>
        <p
          v-if="
            container.full_report_navixy &&
            container.sensors &&
            container.sensors.length > 0 &&
            container.sensors[0].sensor_type == 'navixy'
          "
        >
          <span><FullReportSvg /></span>
          <span>{{ $tc('sensors.navixy.fullReport', container.full_report_navixy) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import FullReportSvg from '@/components/svg/FullReportSvg.vue'

export default {
  name: 'ContainerBaseData',
  props: {
    container: { type: Object, required: true },
    showMap: { type: Boolean, required: false, default: true },
  },
  components: { FullReportSvg },
}
</script>

<style lang="scss" scoped>
.base-data {
  h4 {
    margin-top: 0;
  }

  &__fields {
    display: flex;
    flex-wrap: wrap;

    p {
      margin: 0.25rem 0.5rem 0.5rem 0;
      display: flex;
      min-width: 35%;
      flex: 1;
    }
  }
}
</style>
